import { render, staticRenderFns } from "./subContent.vue?vue&type=template&id=3137e7fc&scoped=true"
import script from "./subContent.vue?vue&type=script&lang=js"
export * from "./subContent.vue?vue&type=script&lang=js"
import style0 from "./subContent.vue?vue&type=style&index=0&id=3137e7fc&prod&lang=scss&scoped=true"
import style1 from "./subContent.vue?vue&type=style&index=1&id=3137e7fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3137e7fc",
  null
  
)

export default component.exports